// extracted by mini-css-extract-plugin
export var standaloneTable = "_e0-0";
export var standaloneTableWithBodyFill = "_e0-1";
export var withExtraHeader = "_e0-2";